import { createIconComponent } from '../../factory/create-icon-component';
export const ThumbsUpIcon = createIconComponent(
  'ThumbsUpIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5449 1.4551L7.81178 6.18822C6.77406 7.22593 6.25521 7.74479 5.88416 8.35029C5.55519 8.88712 5.31276 9.47239 5.16578 10.0846C5 10.7751 5 11.5089 5 12.9764V16.2C5 17.8802 5 18.7202 5.32698 19.362C5.6146 19.9265 6.07354 20.3854 6.63803 20.673C7.27976 21 8.11984 21 9.8 21H16.882C18.3435 21 19.0742 21 19.6644 20.7326C20.1846 20.4969 20.6267 20.1176 20.9388 19.6393C21.2928 19.0966 21.4039 18.3744 21.6262 16.9299L22.1493 13.5299C22.4424 11.6247 22.5889 10.6721 22.3062 9.93088C22.0581 9.28031 21.5914 8.73631 20.9861 8.39213C20.2965 8 19.3327 8 17.4051 8H16.2639C15.3864 8 14.9476 8 14.6502 7.86375C14.1289 7.62501 13.7894 7.11006 13.7753 6.53693C13.7672 6.20985 13.94 5.80657 14.2857 5L15.0718 3.16587C15.5112 2.14057 14.7591 1 13.6436 1C13.2315 1 12.8363 1.1637 12.5449 1.4551Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 8L2 20"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
